var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C7F2C6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E9FAE8",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24V28M26.75 21.5H23.3C21.6198 21.5 20.7798 21.5 20.138 21.827C19.5735 22.1146 19.1146 22.5735 18.827 23.138C18.5 23.7797 18.5 24.6198 18.5 26.3L18.5 27.5C18.5 28.4319 18.5 28.8978 18.6522 29.2653C18.8552 29.7554 19.2446 30.1447 19.7346 30.3477C20.1022 30.5 20.5681 30.5 21.5 30.5V34.75C21.5 34.9821 21.5 35.0982 21.5096 35.196C21.6032 36.1456 22.3544 36.8968 23.304 36.9903C23.4017 37 23.5178 37 23.75 37C23.9822 37 24.0983 37 24.196 36.9903C25.1456 36.8968 25.8968 36.1456 25.9904 35.196C26 35.0982 26 34.9821 26 34.75V30.5H26.75C28.5164 30.5 30.6772 31.4469 32.3443 32.3556C33.3168 32.8858 33.8031 33.1508 34.1216 33.1118C34.4169 33.0757 34.6402 32.9431 34.8133 32.7011C35 32.4401 35 31.918 35 30.8737V21.1263C35 20.082 35 19.5598 34.8133 19.2989C34.6402 19.0569 34.4169 18.9243 34.1216 18.8881C33.8031 18.8491 33.3168 19.1142 32.3443 19.6443C30.6772 20.5531 28.5164 21.5 26.75 21.5Z",
    stroke: "#259C22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/Announcement.f60536a57292709801c2ef502e8d1e9c.svg";
export { ForwardRef as ReactComponent };